import React from 'react';
import cx from 'classnames';

const statusLabels = {
    [1]: 'New Request',
    [2]: 'Searching...',
    [3]: 'Prior Policy Found',
    [4]: 'None Found'
};

const StatusPill = ({ statusId, fallback }) => {
    let label;
    if (statusLabels[statusId] != undefined) {
        label = statusLabels[statusId];
    } else {
        label = fallback;
    }

    const classes = cx(
        'rounded-full', 
        'py-1', 'px-3',
        'text-xs',
        'border',
        {
            ['bg-warning-10 text-warning-60 border-warning-30']: statusId < 3,
            ['bg-success-10 text-success-60 border-succcess-30']: statusId == 3,
            ['bg-error-10 text-error-60 border-error-30']: statusId == 4,
            ['bg-gray-100']: statusId > 4
        }
    );

    return <span className={classes}>{label}</span>;
};

const StatusCell =  ({data,...rest}) => (
    <span {...rest}>
        <StatusPill statusId={data.statusId} fallback={data.status}/>
    </span>
);

export default StatusCell;